import React from 'react';

import { useTranslation } from 'react-i18next';
import { QAlert, QBox } from '@qualio/ui-components';

type IncompleteRequiredFieldsAlertProps = {
  incompleteRequiredFields: string[];
  alertButtonAction: () => void;
};

const IncompleteRequiredFieldsAlert: React.FC<IncompleteRequiredFieldsAlertProps> = ({ incompleteRequiredFields }) => {
  const { t } = useTranslation();
  // ignore typescript:S2871 because alphabetical sort is intended, c.f. https://github.com/SonarSource/SonarJS/issues/4046
  incompleteRequiredFields.sort(); // NOSONAR
  const incompleteFieldsText = <strong>{incompleteRequiredFields.join(', ')}.</strong>;

  return incompleteRequiredFields.length > 0 ? (
    <QAlert
      title={t('common.notifications.missingRequiredFields')}
      status="warning"
      description={
        <QBox>
          {t('events.messages.requiredFieldsMustBeCompletedBeforeApprovalAndClosure')} {incompleteFieldsText}{' '}
          {t('events.messages.editEventToFillMissingRequiredFields')}
        </QBox>
      }
    />
  ) : null;
};

export default IncompleteRequiredFieldsAlert;
